// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","componentWrapper":"_20Yw57fP-Vy98e8bvsRJGX","reducedSpaces":"_19TXF2ygn6tI3Ims4RUC18"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/components/Accordion/constants/accordionsLayouts.css
// module id = 1297
// module chunks = 0